<template>
  <div class="region-container">
    <h2 class="region-container-title">
      {{ locatorRegionsTitle }}
    </h2>
    <section class="accordion">
      <kf-accordion-item
        v-for="(region, i) in locatorRegions"
        :key="i"
        :title="region.locatorRegionName"
      >
        <div class="region-list-container">
          <div
            v-for="(type, j) in region.locatorRegionTypes"
            :key="j"
          >
            <h4 class="h5 region-list-container-title">
              {{ type.locatorRegionTypeName }}
            </h4>

            <ul class="region-list">
              <li
                v-for="(city, k) in type.locatorRegionCities"
                :key="k"
                class="region-list-item"
              >
                <kf-link
                  :href="city.locatorRegionCityUrl"
                  class="region-list-link"
                  @click.native="handleCityClick(city, type, region)"
                >
                  <chevron-right-secondary class="icon" />
                  <span>{{ city.locatorRegionCityName }}</span>
                </kf-link>
              </li>
            </ul>
          </div>
        </div>
      </kf-accordion-item>
    </section>
  </div>
</template>

<script>
import KfAccordionItem from '@/components/accordion/AccordionItem.vue';
import KfLink from '@/components/base/link/Link.vue';
import { trackEvent } from '@/lib/gtm/trackEvent';

export default {
  name: 'KfLocatorRegionList',
  components: {
    KfAccordionItem,
    KfLink,
    ChevronRightSecondary: () =>
      import(/* webpackChunkName: "main"*/ '@/components/svg/ChevronRightSecondary.vue'),
  },
  props: {
    locatorRegionsTitle: {
      type: String,
      default: '',
    },
    locatorRegions: {
      type: Array,
      default: null,
    },
  },
  methods: {
    handleCityClick(city, type, region) {
      trackEvent(
        {
          event: 'choosingCity',
          event_name: 'choosingCity',
          event_category: 'childcareType',
          event_action: 'choosingCity',
          childcare_type: type.locatorRegionTypeName,
          location_place: city.locatorRegionCityName,
          location_province: region.locatorRegionName,
        },
        this.$gtm.enabled(),
      );
    },
  },
};
</script>

<style lang="postcss">
.region {
  &-container {
    @apply flex flex-col;

    &-title {
      @apply text-center;
    }

    .accordion {
      @apply w-full;
    }
  }

  &-list {
    &-container {
      @apply flex w-full justify-between px-4 flex-col;

      @screen md {
        @apply px-8 flex-row;
      }

      &-title {
        @apply mb-3;
      }
    }

    &-item {
      @apply flex;

      .icon {
        @apply w-3 h-3 mr-3;

        path {
          stroke: var(--color-primary-bravo);
        }
      }
    }

    &-link {
      @apply flex items-center;
    }
  }
}
</style>
